(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["necklace-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Bail out if there are no necklace-builder sections on the page.
  const sections = document.querySelectorAll('[data-nb-section]');
  if (!sections.length) return;

  // ---------- helpers ----------
  const $ = (root, sel) => root.querySelector(sel);
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));

  function formatMoney(amountInCents, symbol) {
    const v = (amountInCents / 100);
    // One decimal hide if whole; otherwise 2dp (matches Shopify money_without_trailing_zeros style).
    const s = (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
    return `${symbol}${s}`;
  }

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function haptic(ms = 8) {
    if (navigator.vibrate) try { navigator.vibrate(ms); } catch (e) { /* noop */ }
  }

  // ---------- per-section init ----------
  sections.forEach(initSection);

  function initSection(root) {
    const currencySymbol = root.dataset.currencySymbol || '£';
    const promoEnabled = root.dataset.promoEnabled === 'true';
    const promoThreshold = parseInt(root.dataset.promoThreshold || '3', 10);

    // ----- collect data from the DOM (Liquid wrote it for us) -----
    const chainEls = $$(root, '[data-nb-chain]');
    const pendantEls = $$(root, '[data-nb-pendant]');

    // Per-card metal data. `silver` is undefined for products that don't have
    // a silver variant — those become disabled when the switch is on Silver.
    function readMetals(el) {
      const gold = {
        id: el.dataset.idGold || el.dataset.id,
        image: el.dataset.imageGold || el.dataset.image,
        thumb: el.dataset.thumbGold || el.dataset.thumb,
        price: parseInt(el.dataset.priceGold || el.dataset.price, 10),
        available: (el.dataset.availableGold || el.dataset.available) === 'true',
      };
      const silver = el.dataset.idSilver ? {
        id: el.dataset.idSilver,
        image: el.dataset.imageSilver,
        thumb: el.dataset.thumbSilver,
        price: parseInt(el.dataset.priceSilver, 10),
        available: el.dataset.availableSilver === 'true',
      } : null;
      return { gold, silver };
    }

    const chains = chainEls.map((el, i) => {
      const metals = readMetals(el);
      return {
        idx: i,
        el,
        // active state — refreshed by applyMetal()
        id: metals.gold.id,
        price: metals.gold.price,
        image: metals.gold.image,
        thumb: metals.gold.thumb,
        available: metals.gold.available,
        metals,
        handle: el.dataset.handle,
        title: el.dataset.title,
        cleanTitle: el.dataset.cleanTitle,
        pendantTop: el.dataset.pendantTop,
      };
    });

    const pendantsByEl = new Map();
    pendantEls.forEach((el) => {
      const metals = readMetals(el);
      pendantsByEl.set(el, {
        el,
        id: metals.gold.id,
        price: metals.gold.price,
        image: metals.gold.image,
        thumb: metals.gold.thumb,
        available: metals.gold.available,
        metals,
        handle: el.dataset.handle,
        title: el.dataset.title,
        cleanTitle: el.dataset.cleanTitle,
      });
    });

    // ----- DOM refs -----
    const stage = $(root, '[data-nb-stage]');
    const chainA = $(root, '[data-nb-chain-a]');
    const chainB = $(root, '[data-nb-chain-b]');
    const stack = $(root, '[data-nb-stack]');
    const chainName = $(root, '[data-nb-chain-name]');
    const dotsEl = $(root, '[data-nb-dots]');
    const chipsEl = $(root, '[data-nb-chips]');
    const chainMeta = $(root, '[data-nb-chain-meta]');
    const promoPill = $(root, '[data-nb-promo-pill]');
    const totalEl = $(root, '[data-nb-total]');
    const strikeEl = $(root, '[data-nb-strike]');
    const savingsEl = $(root, '[data-nb-savings]');
    const barLabel = $(root, '[data-nb-bar-label]');
    const addBtn = $(root, '[data-nb-add]');
    const toast = $(root, '[data-nb-toast]');
    const toastText = $(root, '[data-nb-toast-text]');
    const navPrev = root.querySelector('[data-nb-nav="-1"]');
    const navNext = root.querySelector('[data-nb-nav="1"]');
    const metalSwitch = $(root, '[data-nb-metal-switch]');

    // ----- state -----
    const state = {
      chainIdx: -1,
      pendantIds: [], // ordered list of selected variant IDs
      activeLayer: 'a',
      metal: 'gold',
    };

    // ----- metal switch -----
    // Walks every chain + pendant, swaps to the requested metal's variant data,
    // and dims items that don't exist in that metal. If the currently-selected
    // chain has no silver, jumps to the first silver-capable chain. Pendants
    // with no silver are dropped from the active stack.
    function applyMetal(metal) {
      state.metal = metal;
      // toggle button states
      if (metalSwitch) {
        $$(metalSwitch, '.nb__metal-btn').forEach((b) => {
          const active = b.dataset.nbMetal === metal;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-checked', active ? 'true' : 'false');
        });
      }

      // helper: pick metal-or-fallback for a card
      function pickMetal(item) {
        const m = item.metals;
        if (metal === 'silver') return m.silver || null;
        return m.gold;
      }

      // chains
      chains.forEach((c) => {
        const data = pickMetal(c);
        if (!data) {
          // no silver variant — dim the pill but keep gold data so a swap back works
          c.el.classList.add('is-metal-disabled');
        } else {
          c.el.classList.remove('is-metal-disabled');
          c.id = data.id; c.price = data.price; c.image = data.image; c.thumb = data.thumb;
          c.available = data.available;
          // refresh the pill thumbnail
          const thumbImg = c.el.querySelector('.nb__chain-pill-thumb img');
          if (thumbImg) thumbImg.src = data.thumb;
          // refresh the pill price
          const priceEl = c.el.querySelector('.nb__chain-pill-price');
          if (priceEl) priceEl.textContent = formatMoney(data.price, currencySymbol);
        }
      });

      // pendants
      const droppedPendants = [];
      pendantsByEl.forEach((p) => {
        const data = pickMetal(p);
        if (!data) {
          p.el.classList.add('is-metal-disabled');
          // if currently selected, drop it
          const wasSelectedId = p.metals.gold.id;
          const idx = state.pendantIds.indexOf(wasSelectedId);
          if (idx >= 0) {
            state.pendantIds.splice(idx, 1);
            p.el.classList.remove('is-active');
            p.el.setAttribute('aria-pressed', 'false');
            droppedPendants.push(p.title);
          }
        } else {
          p.el.classList.remove('is-metal-disabled');
          // map old id -> new id in any currently-selected stack
          const oldId = p.id;
          if (oldId !== data.id) {
            const idx = state.pendantIds.indexOf(oldId);
            if (idx >= 0) state.pendantIds[idx] = data.id;
          }
          p.id = data.id; p.price = data.price; p.image = data.image; p.thumb = data.thumb;
          p.available = data.available;
          const thumbImg = p.el.querySelector('.nb__pendant-thumb img');
          if (thumbImg) thumbImg.src = data.thumb;
          const priceEl = p.el.querySelector('.nb__pendant-price');
          if (priceEl) priceEl.textContent = formatMoney(data.price, currencySymbol);
        }
      });

      // if current chain has no silver, jump to the first one that does
      if (metal === 'silver' && state.chainIdx >= 0) {
        const cur = chains[state.chainIdx];
        if (!cur.metals.silver) {
          const next = chains.findIndex((c) => c.metals.silver && c.metals.silver.available);
          if (next >= 0) selectChain(next);
        } else {
          selectChain(state.chainIdx);
        }
      } else if (state.chainIdx >= 0) {
        selectChain(state.chainIdx);
      }

      renderStack();
      renderChips();
      updateBar();

      if (droppedPendants.length) {
        showToast(`${droppedPendants.length} pendant${droppedPendants.length > 1 ? 's' : ''} not in silver — removed from your stack`);
      }
    }

    if (metalSwitch) {
      $$(metalSwitch, '.nb__metal-btn').forEach((b) => {
        b.addEventListener('click', () => applyMetal(b.dataset.nbMetal));
      });
    }

    // ----- chain dots -----
    if (dotsEl && chains.length) {
      dotsEl.innerHTML = chains.map(() => '<i></i>').join('');
    }

    // ----- selecting a chain -----
    function selectChain(idx, opts = {}) {
      const next = chains[idx];
      if (!next) return;
      state.chainIdx = idx;

      // Per-chain pendant offset (drives where the pendant lands on the chain U).
      if (next.pendantTop) stage.style.setProperty('--nb-pendant-top', next.pendantTop);
      else stage.style.removeProperty('--nb-pendant-top');

      // cross-fade between A/B layers
      const showLayer = state.activeLayer === 'a' ? chainB : chainA;
      const hideLayer = state.activeLayer === 'a' ? chainA : chainB;
      showLayer.src = next.image;
      const onLoaded = () => {
        showLayer.classList.add('is-active');
        hideLayer.classList.remove('is-active');
        state.activeLayer = state.activeLayer === 'a' ? 'b' : 'a';
        showLayer.removeEventListener('load', onLoaded);
      };
      if (showLayer.complete && showLayer.naturalWidth > 0) {
        onLoaded();
      } else {
        showLayer.addEventListener('load', onLoaded, { once: true });
      }

      // pill states
      chains.forEach((c, i) => {
        c.el.classList.toggle('is-active', i === idx);
        c.el.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });

      // dot indicator
      if (dotsEl) {
        $$(dotsEl, 'i').forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }

      // meta
      if (chainName) chainName.textContent = next.cleanTitle || next.title;
      if (chainMeta) chainMeta.textContent = `${idx + 1} of ${chains.length}`;

      // scroll the active pill into view (gentle)
      if (!opts.fromScroll) {
        next.el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      if (opts.userInitiated) haptic(6);
      updateBar();
    }

    // ----- selecting / unselecting pendants -----
    function togglePendant(p) {
      if (!p.available) return;
      const i = state.pendantIds.indexOf(p.id);
      if (i >= 0) {
        state.pendantIds.splice(i, 1);
        p.el.classList.remove('is-active');
        p.el.setAttribute('aria-pressed', 'false');
      } else {
        state.pendantIds.push(p.id);
        p.el.classList.add('is-active');
        p.el.setAttribute('aria-pressed', 'true');
        haptic(10);
      }
      renderStack();
      renderChips();
      updateBar();
    }

    function pendantById(id) {
      for (const p of pendantsByEl.values()) if (p.id === id) return p;
      return null;
    }

    // ----- preview pendant stack -----
    function renderStack() {
      stack.innerHTML = '';
      const ids = state.pendantIds.slice(0, 6); // cap visual stack
      stack.dataset.count = String(ids.length);
      ids.forEach((id) => {
        const p = pendantById(id);
        if (!p) return;
        const piece = document.createElement('div');
        piece.className = 'nb__pendant-piece';
        const img = document.createElement('img');
        img.src = p.image;
        img.alt = '';
        piece.appendChild(img);
        stack.appendChild(piece);
      });
    }

    // ----- chips beneath preview -----
    function renderChips() {
      chipsEl.innerHTML = '';
      state.pendantIds.forEach((id) => {
        const p = pendantById(id);
        if (!p) return;
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'nb__chip';
        chip.setAttribute('aria-label', `Remove ${p.title}`);
        chip.innerHTML = `
          <img class="nb__chip-img" src="${p.thumb}" alt="">
          <span>${p.cleanTitle || p.title}</span>
          <span class="nb__chip-x" aria-hidden="true">
            <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M2 2 L10 10 M10 2 L2 10"/></svg>
          </span>`;
        chip.addEventListener('click', () => togglePendant(p));
        chipsEl.appendChild(chip);
      });
    }

    // ----- price + bar state -----
    function computeTotals() {
      const chain = chains[state.chainIdx];
      const chainPrice = chain ? chain.price : 0;
      const pendantPrices = state.pendantIds.map((id) => pendantById(id)?.price || 0);
      const subtotal = chainPrice + pendantPrices.reduce((a, b) => a + b, 0);

      let discount = 0;
      let promoUnlocked = false;
      if (promoEnabled && pendantPrices.length >= promoThreshold) {
        // 3-for-2: cheapest pendant per group of 3 is free.
        const sorted = pendantPrices.slice().sort((a, b) => a - b);
        const freeCount = Math.floor(sorted.length / promoThreshold);
        for (let i = 0; i < freeCount; i++) discount += sorted[i];
        promoUnlocked = true;
      }
      return { subtotal, discount, total: subtotal - discount, promoUnlocked, pendantCount: pendantPrices.length };
    }

    function updateBar() {
      const { subtotal, discount, total, promoUnlocked, pendantCount } = computeTotals();
      const oldText = totalEl.textContent;
      const newText = formatMoney(total, currencySymbol);
      totalEl.textContent = newText;
      if (oldText !== newText) {
        totalEl.classList.add('is-bumping');
        setTimeout(() => totalEl.classList.remove('is-bumping'), 350);
      }

      if (discount > 0) {
        strikeEl.hidden = false;
        strikeEl.textContent = formatMoney(subtotal, currencySymbol);
        savingsEl.hidden = false;
        savingsEl.textContent = `Saved ${formatMoney(discount, currencySymbol)} · 3 for 2`;
      } else {
        strikeEl.hidden = true;
        savingsEl.hidden = true;
      }

      // promo pill state
      if (promoPill) {
        promoPill.classList.toggle('is-unlocked', promoUnlocked);
        const label = promoPill.querySelector('[data-nb-promo-label]');
        if (label && promoEnabled) {
          if (promoUnlocked) {
            label.textContent = 'One free pendant unlocked';
          } else if (pendantCount > 0 && pendantCount < promoThreshold) {
            const remaining = promoThreshold - pendantCount;
            label.textContent = `Add ${remaining} more for one free`;
          } else {
            label.textContent = '3 for 2 — drop in 3, get one free';
          }
        }
      }

      // bar label / cta state
      if (state.chainIdx < 0) {
        barLabel.textContent = 'Pick a chain to start';
        addBtn.disabled = true;
      } else if (state.pendantIds.length === 0) {
        barLabel.textContent = `Chain only · 1 piece`;
        addBtn.disabled = false;
        addBtn.querySelector('.nb__bar-cta-text').textContent = 'Add chain to bag';
      } else {
        const n = state.pendantIds.length + 1;
        barLabel.textContent = `Your stack · ${n} pieces`;
        addBtn.disabled = false;
        addBtn.querySelector('.nb__bar-cta-text').textContent = 'Add to bag';
      }
    }

    // ----- add to cart -----
    async function addToCart() {
      if (state.chainIdx < 0) return;
      const chain = chains[state.chainIdx];
      const items = [{ id: parseInt(chain.id, 10), quantity: 1 }];
      // Group identical pendant variants into quantity counts.
      const counts = {};
      state.pendantIds.forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
      Object.entries(counts).forEach(([id, q]) => items.push({ id: parseInt(id, 10), quantity: q }));

      addBtn.classList.add('is-loading');
      addBtn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Could not add to cart');
        }
        await res.json();

        // success state
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-success');
        addBtn.querySelector('.nb__bar-cta-text').textContent = 'Added';
        haptic(20);
        showToast(`${items.reduce((s, i) => s + i.quantity, 0)} pieces added to your bag`);

        // notify the theme — most modern themes (Dawn, Impulse, Symmetry, Refresh, …)
        // listen for one of these to refresh their cart drawer/badge.
        document.documentElement.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { items } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.Shopify && window.Shopify.theme && typeof window.Shopify.theme.cart?.openDrawer === 'function') {
          try { window.Shopify.theme.cart.openDrawer(); } catch (e) {}
        }

        setTimeout(() => {
          addBtn.classList.remove('is-success');
          addBtn.disabled = false;
          updateBar();
        }, 2200);
      } catch (err) {
        addBtn.classList.remove('is-loading');
        addBtn.disabled = false;
        showToast(err.message || 'Something went wrong, please try again', { error: true });
      }
    }

    function showToast(text, { error = false } = {}) {
      toastText.textContent = text;
      toast.classList.toggle('is-error', error);
      toast.classList.add('is-shown');
      clearTimeout(showToast._t);
      showToast._t = setTimeout(() => toast.classList.remove('is-shown'), 2800);
    }

    // ----- swipe gesture on preview to switch chain -----
    let dragX = 0, dragStart = null;
    stage.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragStart = e.clientX;
      stage.setPointerCapture?.(e.pointerId);
    });
    stage.addEventListener('pointermove', (e) => {
      if (dragStart == null) return;
      dragX = e.clientX - dragStart;
    });
    stage.addEventListener('pointerup', () => {
      if (dragStart == null) return;
      if (Math.abs(dragX) > 40 && chains.length) {
        const dir = dragX > 0 ? -1 : 1;
        const next = clamp(state.chainIdx + dir, 0, chains.length - 1);
        if (next !== state.chainIdx) selectChain(next, { userInitiated: true });
      }
      dragStart = null; dragX = 0;
    });
    stage.addEventListener('pointercancel', () => { dragStart = null; dragX = 0; });

    // ----- arrow nav (desktop) -----
    [navPrev, navNext].forEach((b) => {
      if (!b) return;
      b.addEventListener('click', () => {
        const dir = parseInt(b.dataset.nbNav, 10);
        const next = clamp(state.chainIdx + dir, 0, chains.length - 1);
        if (next !== state.chainIdx) selectChain(next, { userInitiated: true });
      });
    });

    // ----- bind selectors -----
    chains.forEach((c, i) => {
      c.el.addEventListener('click', () => selectChain(i, { userInitiated: true }));
    });
    pendantEls.forEach((el) => {
      el.addEventListener('click', () => togglePendant(pendantsByEl.get(el)));
    });
    addBtn.addEventListener('click', addToCart);

    // ----- initial state -----
    const firstAvailable = chains.findIndex((c) => c.available);
    if (firstAvailable >= 0) selectChain(firstAvailable);
    updateBar();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
